// extracted by mini-css-extract-plugin
module.exports = {"container":"_cG","image":"_cH","imageLink":"_cI","content":"_cJ","title":"_cK","link":"_cL","itemWithIcon":"_cM","text":"_cN","linkTitle":"_cO","description":"_cP","button":"_cQ"};